<template>
  <div class="appointment-page">
    <div class="modal-container">
      <div class="modal-grid">
        <!-- 左侧：预约表单 -->
        <div class="form-side">
          <h2>预约专家咨询</h2>
          <p class="subtitle">请填写您的信息，我们的咨询顾问将在1个工作日内与您联系，为您提供一对一的专业解答。</p>

          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="form-group">
                <label>姓名 <span style="color: #E03A3A;">*</span></label>
                <input type="text" placeholder="例如：张明" required>
              </div>
              <div class="form-group">
                <label>联系电话 <span style="color: #E03A3A;">*</span></label>
                <input type="tel" placeholder="13900001234" required>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>公司名称</label>
                <input type="text" placeholder="例如：国家能源集团">
              </div>
              <div class="form-group">
                <label>职位</label>
                <input type="text" placeholder="例如：数据部总经理">
              </div>
            </div>

            <div class="form-group">
              <label>咨询方向 <span style="color: #E03A3A;">*</span></label>
              <select required>
                <option value="" disabled selected>请选择您感兴趣的咨询方向</option>
                <option value="digital">数字化转型咨询</option>
                <option value="data">数据治理咨询</option>
                <option value="audit">审计风控合规咨询</option>
                <option value="ai">AI及大模型咨询</option>
                <option value="cdo">首席数据官(CDO)培训</option>
                <option value="other">其他</option>
              </select>
            </div>

            <div class="form-group">
              <label>留言内容</label>
              <textarea placeholder="请简要描述您的需求或关注的问题..."></textarea>
            </div>

            <button type="submit" class="btn-submit">
              提交预约 <i class="fas fa-arrow-right" style="margin-left: 8px;"></i>
            </button>

            <p class="privacy-note">
              提交即同意 <a href="#">《隐私条款》</a>，我们将严格保护您的个人信息
            </p>
          </form>
        </div>

        <!-- 右侧：两位顾问二维码 + 社群二维码 -->
        <div class="qr-side">
          <h3>扫码添加顾问微信</h3>
          <p class="qr-desc">优先获得一对一咨询，获取最新行业白皮书与课程资料</p>

          <!-- 双二维码区域 -->
          <div class="qr-grid">
            <div class="qr-code-box">
                <img :src="qr1" alt="qr1" class="qr-img-real" />
                <p style="font-size: 12px; color: #8a95a8; margin-top: 8px;">添加顾问微信：Shujujuece</p>
            </div>
            <div class="qr-code-box">
                <img :src="qr2" alt="qr2" class="qr-img-real" />
                <p style="font-size: 12px; color: #8a95a8; margin-top: 8px;">添加顾问微信：Cchenn</p>
            </div>
          </div>

          <!-- 社群二维码卡片（新增） -->
          <div class="community-card">
            <div class="community-qr">
              <img :src="qr3" alt="community" style="width:100%; height:100%; object-fit:cover; border-radius:8px;" />
            </div>
            <div class="community-info">
              <h4>数据决策与企业数字化转型</h4>
              <p style="color: white;">扫码关注公众号<br>加入数据社区 · 阅读最新专业文章  · 获取专题报告</p>
            </div>
          </div>

          <!-- 联系方式卡片 -->
          <div class="contact-info">
            <div class="contact-item">
              联系微信<i class="fas fa-wexin"></i>
              <span>桑老师:Cchenn-- <br> 顾老师:Shujujuece </span>
            </div>
            <div class="contact-item">
              <i class="fas fa-envelope"></i>
              <span>pmo@gushandata.cn</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-clock"></i>
              <span>周一至周五 9:00-18:00</span>
            </div>
          </div>

          <div class="brand-footer">
            <i class="fas fa-shield-alt" style="margin-right: 6px;"></i> 北京古杉数据科技有限公司
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Appointment',
  data() {
    return {
      qr1: require('@/assets/img/qr_gu.jpg'),
      qr2: require('@/assets/img/qr_sang.jpg'),
      qr3: require('@/assets/img/qr_shequ.jpg')
    }
  },
  methods: {
    onSubmit() {
      alert('表单提交成功，我们会尽快联系您！')
    }
  }
}
</script>

<style scoped>
/* Styles adapted from original HTML */
* { box-sizing: border-box; }
.appointment-page { padding: 20px; background-color: var(--bg-light, #f5f7fa); min-height: 100vh; display:flex; align-items:center; justify-content:center; }
:root { --primary-blue: #1F3F8F; --deep-indigo: #0E1F52; --light-porcelain: #EAF0FB; --bg-light: #f5f7fa; --text-dark: #2B2F3A; --card-shadow: 0 25px 50px -12px rgba(0,0,0,0.25); --border-light: #e9edf4; }
.modal-container { max-width: 1150px; width: 100%; background: white; border-radius: 32px; box-shadow: var(--card-shadow); overflow: hidden; animation: modalFadeIn 0.4s ease-out; }
@keyframes modalFadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
.modal-grid { display: grid; grid-template-columns: 1.2fr 1fr; min-height: 750px; }
.form-side { padding: 48px 40px; background: white; }
.form-side h2 { font-size: 28px; font-weight: 700; color: var(--deep-indigo); margin-bottom: 8px; }
.form-side .subtitle { font-size: 16px; color: #5f6a7d; margin-bottom: 32px; line-height: 1.5; }
.form-group { margin-bottom: 20px; }
.form-group label { display: block; font-size: 14px; font-weight: 500; color: var(--text-dark); margin-bottom: 6px; }
.form-group input, .form-group select, .form-group textarea { width: 100%; padding: 14px 18px; border: 1px solid var(--border-light); border-radius: 16px; font-size: 15px; font-family: 'Inter', sans-serif; transition: all 0.3s; background: #fafbfc; }
.form-group input:focus, .form-group select:focus, .form-group textarea:focus { outline: none; border-color: var(--primary-blue); background: white; box-shadow: 0 0 0 4px rgba(31,63,143,0.1); }
.form-group textarea { resize: vertical; min-height: 100px; }
.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.btn-submit { width: 100%; background: #0e3170; color: white; border: none; padding: 16px; border-radius: 60px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.3s; margin-top: 16px; box-shadow: 0 8px 20px rgba(31,63,143,0.2); }
.btn-submit:hover { background: #0e3170; transform: translateY(-2px); box-shadow: 0 12px 28px rgba(31,63,143,0.3); }
.privacy-note { text-align: center; font-size: 13px; color: #8a95a8; margin-top: 20px; }
.privacy-note a { color: var(--primary-blue); text-decoration: none; }
.qr-side { background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%); padding: 48px 28px; color: white; display: flex; flex-direction: column; }
.qr-side h3 { font-size: 24px; font-weight: 600; margin-bottom: 8px; color: white; }
.qr-side .qr-desc { font-size: 15px; line-height: 1.5; margin-bottom: 24px; opacity: 0.9; color:#fafbfc}
.qr-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 24px; }
.qr-code-box { background: white; border-radius: 20px; padding: 20px 12px; text-align: center; box-shadow: 0 10px 20px rgba(0,0,0,0.15); transition: transform 0.2s; }
.qr-code-box:hover { transform: translateY(-2px); }
.qr-icon { width: 200px; height: 200px; background: linear-gradient(145deg, #f0f4fa, #ffffff); margin: 0 auto 12px; border-radius: 12px; display: flex; align-items: center; justify-content: center; border: 1px solid #eef2f6; }
.qr-img-real { width: 200px; height: 200px; object-fit: contain; border-radius: 8px; display: block; margin: 0 auto; }
.advisor-name { font-weight: 600; color: var(--deep-indigo); font-size: 16px; margin-bottom: 4px; }
.advisor-role { font-size: 12px; color: #5f6a7d; line-height: 1.4; }
.community-card { background: rgba(255,255,255,0.1); backdrop-filter: blur(5px); border-radius: 20px; padding: 20px; margin: 16px 0 20px; border: 1px solid rgba(255,255,255,0.2); display: flex; align-items: center; gap: 16px; }
.community-qr { flex-shrink: 0; width: 90px; height: 90px; background: white; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
.community-info h4 { font-size: 16px; font-weight: 600; margin-bottom: 4px; color: white; }
.community-info p { font-size: 13px; opacity: 0.9; line-height: 1.4; }
.contact-info { background: rgba(255,255,255,0.08); border-radius: 20px; padding: 20px; margin-top: 8px; }
.contact-item { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; font-size: 14px; }
.contact-item i { width: 22px; font-size: 18px; opacity: 0.9; }
.brand-footer { margin-top: 20px; text-align: center; opacity: 0.7; font-size: 13px; }
@media (max-width: 900px) { .modal-grid { grid-template-columns: 1fr; } }
@media (max-width: 600px) { .qr-grid { grid-template-columns: 1fr; } .community-card { flex-direction: column; text-align: center; } .form-row { grid-template-columns: 1fr; } .form-side { padding: 32px 24px; } .qr-side { padding: 32px 24px; } .qr-img-real { width: 140px; height: 140px; } }
</style>
